import script from "./boxInfoDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./boxInfoDialog.vue?vue&type=script&lang=ts&setup=true"

import "./boxInfoDialog.vue?vue&type=style&index=0&id=71e428f2&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e428f2"]])

export default __exports__